import { createApiSlice } from "@common";
import { CRUD_ASSIGNMENT_TYPE } from "@routes";

const apiConfig = [
  {
    name: "addAssignmentType",
    method: "post",
    url: CRUD_ASSIGNMENT_TYPE,
    stateKey: "message",
  },
  {
    name: "getAssignmentType",
    method: "get",
    url: CRUD_ASSIGNMENT_TYPE,
    stateKey: "data",
  },
  {
    name: "updateAssignmentType",
    method: "put",
    url: CRUD_ASSIGNMENT_TYPE,
    stateKey: "message",
  },
  {
    name: "deleteAssignmentType",
    method: "delete",
    url: CRUD_ASSIGNMENT_TYPE,
    stateKey: "message",
  },
];

const customReducers = {
  initialState: {
    data: [],
    additionalData: [],
  },
  reducers: {
    setAdditionalData: (state, action) => {
      state.additionalData = action.payload;
    },
  },
  extraReducers: {},
};

const { slice, thunks, actions } = createApiSlice(
"assignmentType",
 apiConfig, 
 customReducers);
const assignmentTypeSlice = slice;

export default assignmentTypeSlice.reducer;

export const {
  addAssignmentType,
  getAssignmentType,
  updateAssignmentType,
  deleteAssignmentType,
} = thunks;

export const { rowSelect } = actions;
